// framework/common/schemas/collections/inviteCodes.js
import { z } from "zod";

const InviteCodeSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    code: z.string().min(3, "Code must be at least 3 characters").describe("The unique, human-readable invite code."),
    maxUses: z.number().int().min(1, "Max uses must be at least 1.").describe("Maximum number of times the code can be used."),
    currentUses: z.number().int().default(0).describe("How many times the code has been used."),
    isEnabled: z.boolean().default(true).describe("Whether the code is currently active."),
    expiresAt: z.coerce.date().optional().nullable().describe("Optional expiration date for the code."),
    notes: z.string().optional().nullable().describe("Administrative notes about the code's purpose or recipient."),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default InviteCodeSchema;